type ResolveStatsigGateValueInput = {
  clientKey?: string;
  userId?: string;
  isInitialized: boolean;
  readGate: () => boolean;
};

export const normalizeStatsigEnvironmentTier = (
  rawTier?: string,
): string | null => {
  const normalizedTier = (rawTier ?? "").trim().toLowerCase();
  return normalizedTier.length > 0 ? normalizedTier : null;
};

export const resolveStatsigGateValue = ({
  clientKey,
  userId,
  isInitialized,
  readGate,
}: ResolveStatsigGateValueInput): boolean => {
  if (!clientKey || !userId || !isInitialized) {
    return false;
  }

  try {
    return Boolean(readGate());
  } catch (_error) {
    return false;
  }
};
